import React from "react";
import DealCard from "../components/DealCard";
import Modal from "../components/Modal";
import Parser from "html-react-parser";
import { useLoading, useDeals, useSearch, usePage } from "../hooks";
import ScrollTop, { GoHome, GoBack } from "../components/ScrollTop";
import Skeleton from '@material-ui/lab/Skeleton';
import Translate from "../components/Translate";
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import { categoryNames } from '../constant';
import { useHistory } from 'react-router-dom';
import InfiniteScroll from "react-infinite-scroll-component";

const DEALS_A_PAGE = 40;
const THRESHOLD = 250;

const CategoryPage = (props) => {
    const history = useHistory();

    const routeChange = React.useCallback((path) => {
        history.push(path);
      }, [history]);

    const category = props.category ? props.category : props.match.params.category;
    let title = props.title ? props.title : categoryNames[category];
    if (title === undefined) {
        routeChange("/");
    }

    const [isLoading] = useLoading();
    const [deals] = useDeals();
    const [searchString] = useSearch();
    const [page, setPage] = usePage();

    const [modalOpen, setModalOpen] = React.useState(false);
    const [store, setStore] = React.useState(undefined);
    const [guide, setGuide] = React.useState(undefined);

    const categoryChip = (
        <Chip
            avatar={<Avatar>C</Avatar>}
            key={category}
            label={title}
            variant="outlined"
            color="primary"
            style={{ position: 'fixed', right: '10px', top: '10px', zIndex: '555' }}
        />
    );

    const categoryDeals = React.useMemo(() => deals.filter(deal => deal.dcat.split(",").includes(category)), [deals, category]);

    const viewDeals = React.useMemo(() => {
        return categoryDeals.filter((deal) => {
            const { dname, dstore, etitle } = deal;
            return dname.toLowerCase().includes(searchString) || dstore.toLowerCase().includes(searchString) || etitle.toLowerCase().includes(searchString);
        });
    }, [categoryDeals, searchString]);

    const totalPage = React.useMemo(() => Math.ceil(viewDeals.length / DEALS_A_PAGE), [viewDeals]);

    const handlePage = React.useCallback((event, value) => {
        window.scroll(0, 0);
        setPage(value);
    }, [setPage]);

    const categoryPosts = React.useMemo(() => {
        if (viewDeals.length > 0) {
            return viewDeals.slice(0, DEALS_A_PAGE * page).map((deal) => (
                <DealCard
                    deal={deal}
                    key={deal.dno}
                    setModalOpen={setModalOpen}
                    setStore={setStore}
                    setGuide={setGuide}
                />
            ));
        }
        return `No ${title} Deals Found!`;
    }, [viewDeals, page, title]);

    const toggle = React.useCallback(() => setModalOpen(!modalOpen), [setModalOpen, modalOpen]);

    const showNumber = categoryDeals.length >= THRESHOLD ? categoryDeals.length : null;

    const skeletons = [...Array(60)].map(x => <div style={{ width: "270px", height: "370px" }}><Skeleton key={x} variant="rect" animation="wave" width={250} height={350} /></div>);

    return (
        <React.Fragment>
            {categoryChip}
            <ScrollTop />
            <GoBack />
            <GoHome setPage={setPage}/>
            <h4 style={{ marginTop: '15px', marginBottom: '5px', marginLeft: '25px' }}>{showNumber} {`${title} Deals`}</h4>
            <div
                style={{ marginLeft: "50px", marginRight: "50px", marginTop: "20px" }}
            >
                <InfiniteScroll
                    dataLength={categoryPosts.length} //This is important field to render the next data
                    next={()=>{setPage(page+1);}}
                    hasMore={(page < totalPage)}
                >
                    <div className="deallist"> {isLoading ? skeletons : categoryPosts}</div>
                </InfiniteScroll>
            </div>
            <Modal isOpen={modalOpen} toggle={toggle} header={`${store} Shopping Guide`} body={guide ? Parser(Translate(guide)) : "No guide available."} />
        </React.Fragment>
    );

};

export default CategoryPage;
